import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHorizontalAlignmentTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"horizontal-alignment-top"} maskId="square-filled-radius-0-stroke-1-IconHorizontalAlignmentTop"><path d="M3 3V4H21V3H3Z" fill="currentColor"/><path d="M6 6V21H11V6H6Z" fill="currentColor"/><path d="M13 6V17H18V6H13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHorizontalAlignmentTop;
